
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créez une landing page et attirez de nouveaux clients",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez comment créer une landing page performante pour vos campagnes afin d'attirer de nouveaux clients et augmenter le chiffre d'affaires de votre entreprise.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Créez une landing page et attirez de nouveaux clients",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Pour attirer de nouveaux clients et développer le chiffre d’affaires de votre entreprise, vous disposez d’outils puissants parmi lesquels la landing page. Cet article vous explique tout.",
        },
      ],
    };
  },
};
